export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('track');
    if (element) {
        tourCriteriaJson.track = element;
    }

    return tourCriteriaJson;
};